import { useOpen, useBlobUrl } from "../../../../../../../libs/hooks";
import { useWorkflowContainerFullStore } from "../../../../../store";
import { Grid } from "@mui/material";
import { OnlyPhoto } from "../../../../../../../libs/shared";

export const CajasConsolidadas = ({widthFull}: {widthFull: string}) => {

  return (
    <Grid 
      container
      justifyContent="flex-start"
      alignContent="flex-start"
      alignItems="flex-start"
      spacing={0}
      sx={{ bgcolor: "white" }}
    >
      <Grid item xs={5} sx={{ m: 1 }}>
        <CajaConsolidadaPhoto widthFull={widthFull} />
      </Grid>
      <Grid item xs={5} sx={{ m: 1 }}>
        <CajaConsolidadaPhoto2 widthFull={widthFull} />
      </Grid>
      <Grid item xs={5} sx={{ m: 1 }}>
        <CajaConsolidadaPhoto3 widthFull={widthFull} />
      </Grid>
      <Grid item xs={5} sx={{ m: 1 }}>
        <CajaConsolidadaPhoto4 widthFull={widthFull} />
      </Grid>
      <Grid item xs={5} sx={{ m: 1 }}>
        <CajaConsolidadaPhoto5 widthFull={widthFull} />
      </Grid>
    </Grid>
  );
};

//CAJA CONSOLIDADA

const CajaConsolidadaPhoto = ({ widthFull }: { widthFull: string }) => {
  const {
    open: openCcon1,
    handleClose: handleCloseCcon1,
    handleOpen: handleOpenCcon1,
  } = useOpen();

  const cajasConsolidadasPhoto1 = useWorkflowContainerFullStore(
    (state) => state.cajasConsolidadasPhoto1
  );

  const setCajasConsolidadasPhoto1 = useWorkflowContainerFullStore(
    (state) => state.setCajasConsolidadasPhoto1
  );
  const fotoUrl = useBlobUrl(cajasConsolidadasPhoto1);


  return (
    <OnlyPhoto
      foto={fotoUrl}
      handleClose={handleCloseCcon1}
      handleOpen={handleOpenCcon1}
      label="FOTO 1"
      open={openCcon1}
      setFoto={setCajasConsolidadasPhoto1}
      width={widthFull === "xs" ? 50 : 130}
    />
  );
};

const CajaConsolidadaPhoto2 = ({ widthFull }: { widthFull: string }) => {
  const {
    open: openCcon2,
    handleClose: handleCloseCcon2,
    handleOpen: handleOpenCcon2,
  } = useOpen();

  const cajasConsolidadasPhoto2 = useWorkflowContainerFullStore(
    (state) => state.cajasConsolidadasPhoto2
  );

  const setCajasConsolidadasPhoto2 = useWorkflowContainerFullStore(
    (state) => state.setCajasConsolidadasPhoto2
  );
  const fotoUrl = useBlobUrl(cajasConsolidadasPhoto2);


  return (
    <OnlyPhoto
      foto={fotoUrl}
      handleClose={handleCloseCcon2}
      handleOpen={handleOpenCcon2}
      label="FOTO 2"
      open={openCcon2}
      setFoto={setCajasConsolidadasPhoto2}
      width={widthFull === "xs" ? 50 : 130}
    />
  );
};

const CajaConsolidadaPhoto3 = ({ widthFull }: { widthFull: string }) => {
  const {
    open: openCcon3,
    handleClose: handleCloseCcon3,
    handleOpen: handleOpenCcon3,
  } = useOpen();

  const cajasConsolidadasPhoto3 = useWorkflowContainerFullStore(
    (state) => state.cajasConsolidadasPhoto3
  );

  const setCajasConsolidadasPhoto3 = useWorkflowContainerFullStore(
    (state) => state.setCajasConsolidadasPhoto3
  );
  const fotoUrl = useBlobUrl(cajasConsolidadasPhoto3);


  return (
    <OnlyPhoto
      foto={fotoUrl}
      handleClose={handleCloseCcon3}
      handleOpen={handleOpenCcon3}
      label="FOTO 3"
      open={openCcon3}
      setFoto={setCajasConsolidadasPhoto3}
      width={widthFull === "xs" ? 50 : 130}
    />
  );
};

const CajaConsolidadaPhoto4 = ({ widthFull }: { widthFull: string }) => {
  const {
    open: openCcon4,
    handleClose: handleCloseCcon4,
    handleOpen: handleOpenCcon4,
  } = useOpen();

  const cajasConsolidadasPhoto4 = useWorkflowContainerFullStore(
    (state) => state.cajasConsolidadasPhoto4
  );

  const setCajasConsolidadasPhoto4 = useWorkflowContainerFullStore(
    (state) => state.setCajasConsolidadasPhoto4
  );
  const fotoUrl = useBlobUrl(cajasConsolidadasPhoto4);


  return (
    <OnlyPhoto
      foto={fotoUrl}
      handleClose={handleCloseCcon4}
      handleOpen={handleOpenCcon4}
      label="FOTO 4"
      open={openCcon4}
      setFoto={setCajasConsolidadasPhoto4}
      width={widthFull === "xs" ? 50 : 130}
    />
  );
};

const CajaConsolidadaPhoto5 = ({ widthFull }: { widthFull: string }) => {
  const {
    open: openCcon5,
    handleClose: handleCloseCcon5,
    handleOpen: handleOpenCcon5,
  } = useOpen();

  const cajasConsolidadasPhoto5 = useWorkflowContainerFullStore(
    (state) => state.cajasConsolidadasPhoto5
  );

  const setCajasConsolidadasPhoto5 = useWorkflowContainerFullStore(
    (state) => state.setCajasConsolidadasPhoto5
  );
  const fotoUrl = useBlobUrl(cajasConsolidadasPhoto5);


  return (
    <OnlyPhoto
      foto={fotoUrl}
      handleClose={handleCloseCcon5}
      handleOpen={handleOpenCcon5}
      label="FOTO 5"
      open={openCcon5}
      setFoto={setCajasConsolidadasPhoto5}
      width={widthFull === "xs" ? 50 : 130}
    />
  );
};
